<script>
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import "@vueform/multiselect/themes/default.css";

export default {
    page: {
        title: "Monthly Statement Listing",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Monthly Statement Listing",
            items: [
                {
                text: "Monthly Statement Listing",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            payment_listing:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
            date: '',
            key_search:'',
            program_id:null,
            programList:null,
            dtKey:0,
            
      
        };
    },

    methods: {
        getPaymentListing(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'customer/payment/list/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.payment_listing = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
    },

    components: {
        DataTable,
    },

    mounted() {
        this.getPaymentListing();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
   <div class="card-body mb-5">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false, ordering: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>
                                            <th scope="col">Payment Id</th>
                                            <th scope="col">Payment Date</th>
                                            <th scope="col">Payment Type</th>
                                            <th scope="col">Amount (RM)</th>
                                            <th scope="col">Pay Status</th>
                                            <th scope="col">Overpaid (RM)</th>
                                            <th scope="col">Invoice</th>
                                            <th scope="col">Payment Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in payment_listing" :key="index" class="content">
                                            <td>{{ index+1 }}</td>
                                            <td>{{item.payment_id}}</td>                               
                                            <td>{{item.payment_date}}</td>
                                            <td>{{item.payment_type}}</td>                                    
                                            <td>{{item.amount}}</td>                                    
                                            <td>{{item.status}}</td>
                                            <td>{{ item.over_paid ? item.over_paid.total_amount : 0 }}</td>
                                            <td>
                                                <span v-if="item.invoices && item.invoices.length">
                                                    <span v-for="(invoice, i) in item.invoices" :key="i">
                                                        {{ invoice.invoice_no }}<span v-if="i < item.invoices.length - 1">, </span>
                                                    </span>
                                                </span>
                                                <span v-else>-</span>
                                            </td>
                                            <td>{{item.payment_description}}</td>                                    
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
</template>
